import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import baseUrl from '../../Base_Url/baseUrl';

export const fetchSurveyStats = createAsyncThunk(
  'surveyStats/fetchSurveyStats',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${baseUrl}/survey/count-surveys`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const surveyStatsSlice = createSlice({
  name: 'surveyStats',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSurveyStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSurveyStats.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSurveyStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectSurveyStats = (state) => state.surveyStats;

export default surveyStatsSlice.reducer;
